// classifiedBlockChrome.js — Shared classification badge DOM helpers for block node views.

import {getClassificationByValue} from '../prosemirror-editor/helpers/classificationLevels';
import {blockClassificationLevel, blockClassificationTokens} from '../../utils/documentHeaderMeta';

export function formatClassificationBadge(level, distribution = [], compartment = []) {
    let result = level;
    if (distribution.length > 0) result += '//' + distribution.join('/');
    if (compartment.length > 0) result += '//' + compartment.join('/');
    return result;
}

/**
 * Apply classification CSS classes and data attributes to a block node root element.
 * @param {HTMLElement} dom
 * @param {object} attrs — node attrs with classificationLevel, distribution, compartment
 */
export function applyClassificationToElement(dom, attrs) {
    const classLevel = blockClassificationLevel(attrs.classificationLevel);
    const distribution = blockClassificationTokens(attrs.distribution, 'distribution');
    const compartment = blockClassificationTokens(attrs.compartment, 'compartment');
    const info = getClassificationByValue(classLevel);

    const keep = dom.className.split(' ').filter((c) => !c.startsWith('classified')).join(' ').trim();
    dom.className = keep;

    if (info) {
        dom.classList.add('classified', `classified-${info.value.toLowerCase()}`);
        dom.setAttribute(
            'data-classification-value',
            formatClassificationBadge(classLevel, distribution, compartment),
        );
        dom.setAttribute('data-classification-label', info.label);
    } else {
        dom.removeAttribute('data-classification-value');
        dom.removeAttribute('data-classification-label');
    }
}

/** True when the click is within the top badge strip of a classified block. */
export function isClassificationBadgeClick(event, dom, hitHeightPx = 20) {
    const rect = dom.getBoundingClientRect();
    return event.clientY <= rect.top + hitHeightPx;
}

/**
 * Open the classification menu for a block node and dispatch attrs update on save.
 */
export function openClassificationMenuForBlock({
    classificationMenu,
    dom,
    attrs,
    event,
    applyResult,
}) {
    if (!classificationMenu) return;
    classificationMenu.openMenu(
        dom,
        {
            classificationLevel: attrs.classificationLevel || 'U',
            distribution: attrs.distribution || [],
            compartment: attrs.compartment || [],
        },
        applyResult,
        event,
    );
}
